{
  "post-office.attachment-consolidation-add-create.spotlight.body": [
    {
      "type": 0,
      "value": "Find your pages, videos, and files in one place. You can search for existing content or upload new files directly."
    }
  ],
  "post-office.attachment-consolidation-add-create.spotlight.got-it": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "post-office.attachment-consolidation-add-create.spotlight.headline": [
    {
      "type": 0,
      "value": "Confluence and Loom are now in Attachments"
    }
  ],
  "post-office.jira-issue-view-contextual-survey.dismiss-label": [
    {
      "type": 0,
      "value": "Dismiss survey"
    }
  ],
  "post-office.jira-issue-view-contextual-survey.highest-score-label": [
    {
      "type": 0,
      "value": "Very easy"
    }
  ],
  "post-office.jira-issue-view-contextual-survey.lowest-score-label": [
    {
      "type": 0,
      "value": "Not very easy"
    }
  ],
  "post-office.jira-issue-view-contextual-survey.question": [
    {
      "type": 0,
      "value": "We’d love to hear from you"
    }
  ],
  "post-office.jira-issue-view-contextual-survey.scale-button-label": [
    {
      "type": 1,
      "value": "score"
    },
    {
      "type": 0,
      "value": " out of 5"
    }
  ],
  "post-office.jira-issue-view-contextual-survey.statement": [
    {
      "type": 0,
      "value": "How easy is it to get work done in this view?"
    }
  ],
  "post-office.jira-issue-view-contextual-survey.submit-label": [
    {
      "type": 0,
      "value": "Submit"
    }
  ],
  "post-office.jira-issue-view-contextual-survey.text-description": [
    {
      "type": 0,
      "value": "Your feedback will be used to improve our products."
    }
  ],
  "post-office.jira-issue-view-contextual-survey.text-label": [
    {
      "type": 0,
      "value": "What influenced your rating? (optional)"
    }
  ],
  "post-office.jira-issue-view-contextual-survey.thank-you": [
    {
      "type": 0,
      "value": "Thanks for your feedback"
    }
  ]
}